import { Button, Empty, Spin } from 'antd';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../Core/Icon';
import { iconComponents } from '../../Core/IconImports';

interface EmptyTableOverlayProps {
  isVisible: boolean;
  isLoading: boolean;
  icon: keyof typeof iconComponents;
  label: string;
  variant?: 'empty' | 'error';
  onRetry?: () => void;
}

const EmptyTableOverlay = ({
  isVisible,
  isLoading,
  icon,
  label,
  variant = 'empty',
  onRetry,
}: EmptyTableOverlayProps) => {
  const { t } = useTranslation();
  const showRetry = variant === 'error' && !!onRetry && !isLoading;

  return (
    <div
      className={clsx(
        'z-overlay absolute inset-0 top-24 flex items-center justify-center',
        'bg-white',
        'transition duration-200 ease-in-out',
        isVisible ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0',
      )}
    >
      <Empty
        image={<Icon name={icon} className="text-gray-medium h-28 w-28" />}
        description={
          <div className="flex flex-col items-center gap-3">
            <div className="flex flex-row items-center gap-2">
              <Spin size="small" spinning={isLoading} />
              <span className="text-gray-dark">{label}</span>
            </div>
            {showRetry ? (
              <Button type="primary" size="small" onClick={onRetry}>
                {t('common.retry')}
              </Button>
            ) : null}
          </div>
        }
      />
    </div>
  );
};

export default EmptyTableOverlay;
